import { render, staticRenderFns } from "./PercentageSelector.vue?vue&type=template&id=22b34f5a&scoped=true&"
import script from "./PercentageSelector.vue?vue&type=script&lang=js&"
export * from "./PercentageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b34f5a",
  null
  
)

export default component.exports